import { jsxs as e, Fragment as t, jsx as a } from "react/jsx-runtime";
import i from "../Controls/PaginationStepControl.js";
import r from "../Controls/PaginationListItem.js";
import "../Controls/PaginationLink.js";
var o = function o(_o) {
  var n = _o.baseUrl,
    l = _o.children,
    c = _o.selectedPage,
    s = _o.selectPage,
    d = _o.total,
    u = _o.dataTrack,
    f = _o.level,
    g = _o.position,
    m = _o.cta,
    p = _o.surface,
    h = function h(e) {
      null == s || s(e);
    },
    P = c === d;
  return e(t, {
    children: [a(r, {
      $marginSide: "right",
      "aria-hidden": 1 === c,
      children: a(i, {
        direction: "previous",
        baseUrl: n,
        selectedPage: c,
        total: d,
        onClick: h,
        cta: m,
        position: g,
        level: f,
        dataTrack: u,
        surface: p
      })
    }), l, a(r, {
      $marginSide: "left",
      "aria-hidden": P,
      children: a(i, {
        direction: "next",
        baseUrl: n,
        selectedPage: c,
        total: d,
        onClick: h,
        cta: m,
        position: g,
        level: f,
        dataTrack: u,
        surface: p
      })
    })]
  });
};
o.defaultProps = {
  total: 20,
  selectedPage: 10,
  surface: "light",
  children: null
};
export { o as default };